import React from 'react';
import { Table } from 'semantic-ui-react';
import { columnName, columnValidationDate, columnTools } from '@/constants/fields';
import TableWrapper from '@/components/table/TableWrapper';
import DataManagementDataModelTableColumns from './DataManagementDataModelTableColumns';
import DataManagementDataModelTableRow from './DataManagementDataModelTableRow';

const DataManagementDataModelTable = ({ category, code }) => {
  const columns = [columnName, columnValidationDate, columnTools];

  return (
    <TableWrapper
      celled
      solid
      selectable
      sticky
      className="aridhia-data-model-data-management-table"
      columns={columns}
    >
      <Table.Header>
        <DataManagementDataModelTableColumns columns={columns} />
      </Table.Header>
      <Table.Body>
        <DataManagementDataModelTableRow category={category} code={code} columns={columns} />
      </Table.Body>
    </TableWrapper>
  );
};

export default DataManagementDataModelTable;
